import { FunctionComponent } from "react";
import { styles } from "../styles/themes/style";
import styled from "styled-components";
import Text, { ITextProps } from "./Text";
import SvgFragment from "../fragments/SvgFragment";

interface IStyledActionTextProps extends ITextProps {
    danger?: boolean,
    cancel?: boolean,
    variable?: boolean,
    invertedVariable?: boolean,
    faded?: boolean,
    $disabled?: boolean,
    className?: string,
    backgroundColor?: string,
    padding?: string,
    isSelected?: boolean,
    textDecoration?: string,
    borderHover?: boolean,
    $regular?: boolean,
}

interface IActionTextProps extends IStyledActionTextProps {
    onClickHandler: (e: any) => void;
    icon?: string;
}

const ActionText: FunctionComponent<IActionTextProps> = ({ isSelected, children, onClickHandler, $disabled, danger, cancel, variable, invertedVariable, faded, icon, className, backgroundColor, padding, textDecoration, borderHover, $regular, ...props }) => {
  return (
      <StyledActionText className={className} isSelected={isSelected} danger={danger} cancel={cancel} $disabled={$disabled} variable={variable} faded={faded} invertedVariable={invertedVariable} backgroundColor={backgroundColor} padding={padding} textDecoration={textDecoration} borderHover={borderHover} onClick={(e) => !$disabled && onClickHandler(e)}>
          {icon && <IconContainer>
            <SvgFragment type={icon} />
            </IconContainer> }
          <Text $bold={!$regular} {...props}>
              {children}
          </Text>
      </StyledActionText>
  )
}

const StyledActionText = styled.div<IStyledActionTextProps>`
    display: flex;
    align-items: center;

    ${({ backgroundColor, borderHover }) => (backgroundColor && borderHover) && `border: 1px solid ${backgroundColor};`};

    ${({ backgroundColor, padding, isSelected }) => backgroundColor && `
        background-color: ${backgroundColor};
        padding: ${padding ? padding : '10px'};
        border-radius: 5px;
        ${isSelected && `border: 1px solid ${styles.colors.primary600}`};
    `}

    span {
        color: ${styles.colors.primary600};
        ${({ danger }) => danger && `color: ${styles.colors.red600};`}
        ${({ cancel }) => cancel && `color: ${styles.colors.black300};`}
        ${({ variable, theme: { primaryColor } }) => variable && `color: ${primaryColor};`}
        ${({ invertedVariable, theme: { secondaryColor } }) => invertedVariable && `color: ${secondaryColor};`}
        ${({ faded, theme: { quaternaryColor } }) => faded && `color: ${quaternaryColor};`}
        ${({ textDecoration }) => textDecoration ? `text-decoration: ${textDecoration};` : 'text-decoration: none'}
    }

    &:hover{
        cursor: pointer;
        span { 
            ${({ borderHover }) => !borderHover && `color: ${styles.colors.primary400};`};
             ${({ danger }) => danger && `color: ${styles.colors.red500};`}
        }

        ${({ borderHover }) => borderHover && `border: 1px solid ${styles.colors.primary600};`};
    } 
    &:focus{
        ${({ borderHover }) => !borderHover && `span { color: ${styles.colors.primary300}; }`};
        ${({ danger }) => danger && `color: ${styles.colors.red400};`}
    }

    ${({ $disabled }) => $disabled && `
        cursor: default;
        span, &:hover span, &:focus span{
            cursor: default;
            color: ${styles.colors.disabledState};
        }
    `}
`;

const IconContainer = styled.div`
  margin-right: 8px;
`;

export default ActionText;
